import React,{Component} from 'react';
import "./header/Header.css" 
import "../scss/general.css";
//import { MonthPickerDropdown from 'react-month-picker-dropdown';
import 'react-month-picker-dropdown/dist/index.css';
 
import '../scss/green-theme.css';
import Cookies from 'universal-cookie';
const monthsname=["January","February","March","April","May","June","July","August","September","October","November","December"];
const cyear=new Date().getFullYear();
const years = [cyear,cyear-1,cyear-2,cyear-3,cyear-4];
const axios = require("axios");
const cookies=new Cookies()
export default class Content extends Component{
  constructor(props)
  {
    super(props);
    this.state=
    { input:{},
      myitems:[],
      isLoaded: false,
      isData: false,
      MonthFrom: 1,
      MonthTo: 1,
      selectedMonthFrom: 1,
      selectedMonthTo: 1,
      selectedYearFrom: years[0],
      selectedYearTo: years[0]
    };
    this.handlechange = this.handlechange.bind(this);
  }
  cur(num) {
    let cnum=parseInt(num,0);
    if(cnum > 0)

        return cnum.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    else
        return "-"
 }
    handlechange(e){
      let input=this.state.input;
     // window.alert(this.state.selectedMonthFrom);
      input["ID"]="101006";
      input["selectedMonthFrom"]=this.state.MonthFrom;
      input["selectedMonthTo"]=this.state.MonthTo;
//      input["selectedMonthFrom"]=this.state.selectedMonthFrom;
      input["selectedYearFrom"]=this.state.selectedYearFrom;
//      input["selectedMonthTo"]=this.state.selectedMonthTo;
      input["selectedYearTo"]=this.state.selectedYearTo;
      console.log(this.state.input);

      this.setState({input});
      this.setState({isLoaded: false});
      axios({
          method: 'post',
          url: cookies.get("phpclass")+'/index.php/user/incometax/',
          data: this.state.input,
          headers: {'Content-Type': 'multipart/form-data'}
      })
      .then((response)=> {
          console.log(response);
          this.setState({
              isLoaded: true,
              myitems: response.data
          });
      })
      .catch(function (response) {
          //handle error
          console.log(response);

      });      
  }
    render()
    {
      let isLoaded = this.state.isLoaded;
      let items = this.state.myitems;
      if(!isLoaded){
      return(
        <div className="container1">
          <h3>Income Tax detail</h3>
            <div width="400px" height="250px" align="left" >
            <table width="250px" height="150px" >
                <tr></tr>
                <tr height="15px">
                  <td width="150px" align="left" padding="1px">From: </td>
                  <td width="100px" align="right" padding="1px">
                    <select
                      name="monthfrom"
                      value={monthsname[this.state.selectedMonthFrom]}
                      width = "75px"
                      height = "20px"
                      onChange={(e) => this.setState({selectedMonthFrom: monthsname[e.target.value],MonthFrom: e.target.value})}>
                      {monthsname.map((option,i) => (
                      <option key={option} value={i}>
                        {option}
                      </option>
                      ))}
                    </select>
                  </td>
                  <td width="60px" align="left" padding="1px">
                    <select
                      value={this.state.selectedYearFrom}
                      onChange={(e) => this.setState({selectedYearFrom: e.target.value})}>
                      {years.map((option) => (
                      <option key={option} value={option}>
                        {option}
                      </option>
                      ))}
                    </select>        
                  </td>
                </tr>
                <tr height="15px">
                  <td width="150px" align="left" padding=".5px">To: </td>
                  <td width="100px" align="right" padding=".5px">
                    <select
                      value= {monthsname[this.state.selectedMonthTo]}
                      width = "75px"
                      height = "20px"
                      onChange={(e) => this.setState({selectedMonthTo: monthsname[e.target.value],MonthTo: e.target.value})}>
                      {monthsname.map((option, i) => (
                      <option key={option} value={i}>
                        {option}
                      </option>
                      ))}
                    </select>
                  </td>
                  <td width="60px" align="left" padding="1px">
                    <select
                      value={this.state.selectedYearTo}
                      onChange={(e) => this.setState({selectedYearTo: e.target.value})}>
                      {years.map((option) => (
                      <option key={option} value={option}>
                        {option}
                      </option>
                      ))}
                    </select>        
                  </td>
                </tr>
                <tr align="right" height="50px">
                  <td colspan="3">
                    <button onClick={this.handlechange} align="right"> submit</button>
                  </td>
                </tr>        
              </table>
          </div>

        </div>
      )
    }
    else
    {
      return(
        <div className="container1">
            <h3>Income Tax detail</h3>
            <div width="300px" height="150px" align="left" >
            <table width="250px" height="150px" >
                <tr></tr>
                <tr height="15px">
                  <td width="150px" align="left" padding="1px">From: </td>
                  <td width="100px" align="right" padding="1px">
                    <select
                      name="monthfrom"
                      value={monthsname[this.state.selectedMonthFrom]}
                      width = "75px"
                      height = "20px"
                      onChange={(e) => this.setState({selectedMonthFrom: monthsname[e.target.value],MonthFrom: e.target.value})}>
                      {monthsname.map((option, i) => (
                      <option key={option} value={i}>
                        {option}
                      </option>
                      ))}
                    </select>
                  </td>
                  <td width="60px" align="left" padding="1px">
                    <select
                      value={monthsname[this.state.selectedYearFrom]}
                      onChange={(e) => this.setState({selectedYearFrom: e.target.value})}>
                      {years.map((option) => (
                      <option key={option} value={option}>
                        {option}
                      </option>
                      ))}
                    </select>        
                  </td>
                </tr>
                <tr height="15px">
                  <td width="150px" align="left" padding=".5px">To: </td>
                  <td width="100px" align="right" padding=".5px">
                    <select
                      value= {monthsname[this.state.selectedMonthTo]}
                      width = "75px"
                      height = "20px"
                      onChange={(e) => this.setState({selectedMonthTo: monthsname[e.target.value],MonthTo: e.target.value})}>
                      {monthsname.map((option, i) => (
                      <option key={option} value={i}>
                        {option}
                      </option>
                      ))}
                    </select>
                  </td>
                  <td width="60px" align="left" padding="1px">
                    <select
                      value={this.state.selectedYearTo}
                      onChange={(e) => this.setState({selectedYearTo: e.target.value})}>
                      {years.map((option) => (
                      <option key={option} value={option}>
                        {option}
                      </option>
                      ))}
                    </select>        
                  </td>
                </tr>
                <tr align="right" height="50px">
                  <td colspan="3">
                    <button onClick={this.handlechange} align="right"> submit</button>
                  </td>
                </tr>        
              </table>
          </div>


          <section className="content-header">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="box">
{/*}                                <div className="box-header with-border">
                                    <h3 className="box-title">Yearly Payslip</h3>
                                </div>
                      */}
                                <br></br>
                                <div className="box-body">
                                    <table>
                                        <thead>
                                        <tr className="tr">
                                            <th className="th" scope="col">Month</th>
                                            <th className="th" scope="col">Year</th>
{/*}                                            <th className="th" scope="col">Groass Salary</th>
                                            <th className="th" scope="col">Medical</th>*/}
                                            <th className="th" scope="col">Taxable Income</th>
                                            <th className="th" scope="col">Income Tax</th>
                                            <th className="th" scope="col">Income Tax adjusted</th>
                                            <th className="th" scope="col">Total Income Tax</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {items.map((result ,i) => {
                                            return (
                                            <tr className="trc" key={i}>
                                            <td className="td" >{monthsname[result.month-1]}</td>
                                            <td className="td">{result.year}</td>
   {/*}                                         <td className="td">{this.cur(result.gross)}</td>*/}
                                            <td className="td" >{this.cur(result.taxable)}</td>
                                            <td className="td" >{this.cur(result.income_tax)}</td>
                                            <td className="td" >{this.cur(result.taxadjust)}</td>
                                            <td className="td" >{this.cur(result.totalincome_Tax)}</td>

                                           {/* <td className="td">{result.NET}</td>
                                            <td className="td"><button type="button"  onClick={() => {this.handleClick(result.month,result.year)}}>View</button></td>*/}
                                            </tr>
                                        )})}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
        </section>
          </div>



        )
    }

    
      
    }
}